import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './DotPagination.styles';
const DotPagination = ({ ariaLabel, count, value, onChange, site = 'ess', }) => {
    const [active, setActive] = React.useState(value);
    React.useEffect(() => {
        setActive(value);
    }, [value]);
    if (count === 1) {
        return null;
    }
    return (React.createElement(S.Container, { "aria-label": ariaLabel, "data-site": site }, Array.from(Array(count)).map((_, index) => {
        return (React.createElement("div", { key: `DotPaginationItem_${index}` },
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Item, { "aria-current": index === active, "aria-label": `Go to ${index + 1}`, role: "button", ...(site === 'ess'
                        ? { as: 'span' }
                        : {
                            onClick: (event) => {
                                event.preventDefault();
                                onChange(index);
                            },
                        }) }))));
    })));
};
export default DotPagination;
